import React, { FC, ReactNode, useState } from 'react'
import { useId } from '@reach/auto-id'
import SlideDown from 'react-slidedown'
import { Icon } from '../Icon'
import cx from 'classnames'
import styles from './Disclosure.module.scss'
import 'react-slidedown/lib/slidedown.css'

type DisclosureProps = {
  children: ReactNode
  className?: string
  defaultOpen?: boolean
  id?: string
  title: ReactNode
}

const arrowIcon = (isOpen: boolean) => (isOpen ? 'arrow-up-s-line' : 'arrow-down-s-line')

// WAI-ARIA https://www.w3.org/TR/wai-aria-practices-1.1/#disclosure
export const Disclosure: FC<DisclosureProps> = ({
  children,
  className,
  defaultOpen = false,
  id,
  title,
}) => {
  const [isOpen, setOpen] = useState(defaultOpen)
  const disclosureId = useId(id)

  return (
    <section className={cx(styles.disclosure, className)}>
      <button
        className={styles.disclosureHeader}
        aria-expanded={isOpen}
        aria-controls={`${disclosureId}-content`}
        onClick={() => setOpen(!isOpen)}
      >
        <span id={`${disclosureId}-title`} className={styles.disclosureTitle}>
          {title}
        </span>
        <Icon name={arrowIcon(isOpen)} className={styles.disclosureIcon} />
      </button>
      <SlideDown className={styles.disclosureSlide}>
        {isOpen ? (
          <div
            id={`${disclosureId}-content`}
            className={styles.disclosureContent}
            aria-labelledby={`${disclosureId}-title`}
          >
            {children}
          </div>
        ) : null}
      </SlideDown>
    </section>
  )
}

Disclosure.displayName = 'Disclosure'
